import { asyncActionFactory } from '@Utils/Redux/asyncAction';
import { logAsyncError } from '@Utils/Decorators';
import { saveRcsSupplierDataByIdType } from './RcsSupplierInfoReducer';

import { getSupplierInfo } from './RcsSupplierInfoService';

export function saveRcsSupplierDataById(supplierInfo, databaseId, crn) {
  return {
    type: saveRcsSupplierDataByIdType,
    payload: {
      crn,
      databaseId,
      item: supplierInfo,
    },
  };
}

export const fetchSupplierInfoSpec = {
  getKey: (crn, databaseId) => () => databaseId + crn,
  action: (crn, databaseId) =>
    logAsyncError(async (dispatch) => {
      const params = {
        databaseId,
        crn,
      };
      const supplierInfo = await getSupplierInfo(params);

      dispatch(saveRcsSupplierDataById(supplierInfo, databaseId, crn));
    }),
};

export const fetchSupplierInfo = asyncActionFactory(fetchSupplierInfoSpec);
